import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getImgeUrl } from 'src/environments/environment';

@Component({
  selector: 'app-home-event',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './home-event.component.html',
  styleUrl: './home-event.component.scss'
})
export class HomeEventComponent {

  isToggled = false;
	events
	imageUrl = getImgeUrl()

	constructor(
	  public themeService: ThemeCustomizerService,
	  private publicService: PublicServiceService
	) {
	  this.themeService.isToggled$.subscribe(isToggled => {
		this.isToggled = isToggled;
	  });
	}
  
	toggleTheme() {
	  this.themeService.toggleTheme();
	}
  
	ngOnInit(): void { 
	  this.getData()
	}
  
	getData() {
		this.publicService.getRecordHome(this.publicService.EVENT_URL).subscribe({
		  next: (res) => {
			this.events = res
	
		  },
		  error: (error) => {
			console.error("here goes the Unexpected error:", error);
		  }
		})
	  }


}
